import * as React from 'react';
export const IcCloudSync = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.75 9.07c-.6-1.78-2.26-3.08-4.25-3.08-1.99 0-3.6 1.26-4.22 3H8c-2.76 0-5 2.24-5 5s2.24 5 5 5h9c2.76 0 5-2.24 5-5 0-2.51-1.85-4.56-4.25-4.92zm-7.73 6.72c-.21 0-.41-.08-.56-.23l-1.6-1.6a.803.803 0 010-1.13c.31-.31.82-.31 1.13 0l.26.26c.16-2.07 1.87-3.7 3.97-3.7.31 0 .64.05 1 .14.42.11.68.54.58.98-.11.43-.55.68-.98.58a2.36 2.36 0 00-.6-.09c-1.2 0-2.19.88-2.36 2.03l.2-.2c.31-.31.82-.31 1.13 0 .31.31.31.82 0 1.13l-1.6 1.6c-.16.16-.36.23-.56.23h-.01zm8.58-1.83c-.16.16-.36.23-.57.23-.21 0-.41-.08-.57-.23l-.26-.26c-.16 2.07-1.87 3.7-3.97 3.7-.31 0-.64-.05-1-.14a.818.818 0 01-.58-.98.81.81 0 01.98-.58c.23.06.42.09.6.09 1.2 0 2.19-.88 2.36-2.03l-.2.2c-.31.31-.82.31-1.13 0a.803.803 0 010-1.13l1.6-1.6c.31-.31.82-.31 1.13 0l1.6 1.6c.31.31.31.82 0 1.13h.01z'
      fill='currentColor'
    />
  </svg>
);
